import { ArrowLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { useT } from '@/i18n'

/** 中列顶部的粘性标题栏。 */
export function PageHeader({
  title,
  subtitle,
  back = false,
  children,
}: {
  title: ReactNode
  subtitle?: string
  back?: boolean
  children?: ReactNode
}) {
  const t = useT()
  const navigate = useNavigate()

  return (
    <div className="sticky top-0 z-20 border-b border-line bg-surface/85 backdrop-blur">
      <div className="flex items-center gap-4 px-4 py-3">
        {back && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            aria-label={t('common.back')}
            className="-ml-2 rounded-md p-2 hover:bg-surface-hover"
          >
            <ArrowLeft className="size-5" />
          </button>
        )}
        <div className="min-w-0">
          <h1 className="truncate text-xl font-extrabold leading-tight">{title}</h1>
          {subtitle && <p className="truncate text-[13px] text-ink-muted">{subtitle}</p>}
        </div>
      </div>
      {children}
    </div>
  )
}
